"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _Toast = require("@react/react-spectrum/Toast");

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

var _CommentList = _interopRequireDefault(require("../CommentList/CommentList"));

var _OfflineNoticeToast = _interopRequireDefault(require("../OfflineNoticeToast"));

var _CommentListView = _interopRequireDefault(require("./CommentListView.scss"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CommentListView = function CommentListView(props) {
  var activeSectionInputFocused = props.activeSectionInputFocused,
      closeButtonClicked = props.closeButtonClicked,
      commentListMinimized = props.commentListMinimized,
      comments = props.comments,
      filter = props.filter,
      guestLoginToast = props.guestLoginToast,
      hasError = props.hasError,
      imsData = props.imsData,
      isFiltered = props.isFiltered,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? true : _props$isLoading,
      onHeightChange = props.onHeightChange,
      onShare = props.onShare,
      onToastClose = props.onToastClose,
      scrollToTop = props.scrollToTop,
      setUnmappedView = props.setUnmappedView,
      showAllScreenComments = props.showAllScreenComments,
      touchControls = props.touchControls,
      viewingUnmappedSection = props.viewingUnmappedSection;
  (0, _react.useEffect)(function () {
    if (guestLoginToast && guestLoginToast.toastType === 'success') {
      setTimeout(onToastClose, _constants.TOAST_TIMEOUT);
    }
  }, [guestLoginToast, onToastClose]);

  var _useContext = (0, _react.useContext)(_AppContext.default),
      _useContext$assetData = _useContext.assetData,
      assetData = _useContext$assetData === void 0 ? {} : _useContext$assetData,
      cacheComments = _useContext.cacheComments,
      compactLayout = _useContext.compactLayout,
      disableCommentCreation = _useContext.disableCommentCreation,
      isOffline = _useContext.isOffline;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommentListView.default.component, _defineProperty({}, _CommentListView.default.compactInputFocused, activeSectionInputFocused))
  }, /*#__PURE__*/_react.default.createElement(_CommentList.default, {
    activeSectionInputFocused: activeSectionInputFocused,
    assetData: assetData,
    cacheComments: cacheComments,
    closeButtonClicked: closeButtonClicked,
    commentListMinimized: commentListMinimized,
    comments: comments,
    compactLayout: compactLayout,
    disableCommentCreation: disableCommentCreation,
    filter: filter,
    hasError: hasError,
    imsData: imsData,
    isFiltered: isFiltered,
    isLoading: isLoading,
    isOffline: isOffline,
    onHeightChange: onHeightChange,
    onShare: onShare,
    scrollToTop: scrollToTop,
    setUnmappedView: setUnmappedView,
    showAllScreenComments: showAllScreenComments,
    touchControls: touchControls,
    viewingUnmappedSection: viewingUnmappedSection
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _CommentListView.default.toastContainer
  }, guestLoginToast && /*#__PURE__*/_react.default.createElement(_Toast.Toast, {
    closable: true,
    onClose: onToastClose,
    variant: guestLoginToast.toastType
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: guestLoginToast.toastMessageId
  })), /*#__PURE__*/_react.default.createElement(_OfflineNoticeToast.default, {
    isOffline: isOffline
  })));
};

CommentListView.propTypes = {
  activeSectionInputFocused: _propTypes.default.bool,
  closeButtonClicked: _propTypes.default.bool,
  commentListMinimized: _propTypes.default.bool,
  comments: _propTypes.default.array,
  filter: _propTypes.default.string,
  guestLoginToast: _propTypes.default.object,
  hasError: _propTypes.default.bool,
  imsData: _propTypes.default.object,
  isFiltered: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  onHeightChange: _propTypes.default.func,
  onShare: _propTypes.default.func,
  onToastClose: _propTypes.default.func,
  scrollToTop: _propTypes.default.bool,
  setUnmappedView: _propTypes.default.func,
  showAllScreenComments: _propTypes.default.bool,
  touchControls: _propTypes.default.bool,
  viewingUnmappedSection: _propTypes.default.bool
};
var _default = CommentListView;
exports.default = _default;